// Display metadata for staff_training_assignments.status.
export const TRAINING_STATUSES = {
    pending:   { label: 'Pending',   color: 'grey' },
    submitted: { label: 'Submitted', color: 'blue' },
    verified:  { label: 'Verified',  color: 'green' },
    rejected:  { label: 'Rejected',  color: 'red' },
}

export function statusMeta(status) {
    return TRAINING_STATUSES[status] || { label: status, color: 'grey' }
}

// Must match PHP upload_max_filesize on the API server.
export const MAX_CERTIFICATE_MB = 8
